import { AdditionalField, Address, AfterBreak, Break, ClockIn, ClockOut, Color, DateLang, EmployeID, EmployeIdentityID, EmployeIDFile, Gender, Group, LangActivate, LangActivation, LangAddToPersonnelPayroll, LangAllowShiftExchange, LangAnnotation, LangAnnualLeaveRequest, LangApplicableOn, LangApplicableTo, LangApprovalAmount, LangApprovalRules, LangApprovalStatus, LangAssignToNewEmployee, LangAttendAfterBreak, LangAttendanceDate, LangAttendBreak, LangAttendFinishOvertime, LangAttendIn, LangAttendOut, LangAttendOvertime, LangAutomaticClockout, LangBalance, LangBccTo, LangBirthDate, LangBirthPlace, LangBloodType, LangCanModifyDocumentEmployee, LangCanModifyEmployee, LangCanModifyAnnualLeaveSetting, LangCanModifyShiftSchedule, LangSpvLimitPersonnelView, LangCanModifyPresence, LangCanSeeInfoDevice, LangCanSeeLocationMap, LangCanSeeSelfiePhoto, LangChangeSpcEmployee, LangChangeSpcGroup, LangClientVisit, LangClientVisitMustOnSpot, LangCreatedBy2, LangDeduction, LangDescription, LangDeviceId, LangDeviceManufacture, LangDeviceModel, LangDeviceName, LangDeviceType, LangDeviceValidation, LangDeviceValidationActivate, LangDocumentName, LangDomicileAddress, LangDomicileCity, LangDomicileProvince, LangDragableLocation, LangDuration, LangEarnings, LangEducationLevel, LangEducationMajor, LangEffectiveDate, LangEmergencyContact, LangEmployeeId, LangEnd, LangEndDate, LangExceptionReceiver, LangExpenses, LangExpiredDate, LangExpiredIn, LangFile, LangFirstTimeAttendance, LangFullfilled, LangGraduationYear, LangIdentityAddress, LangIdentityCity, LangIdentityNumber, LangIdentityProvince, LangIdentityType, LangInstitutionName, LangJobDescription, LangLateAfterBreak, LangLateCharge, LangLateness, LangLateToleranceSecond, LangLeaveApprovedAt, LangLeaveDayRequestNotif, LangLeaveExpiredAt, LangLeaveHourRequest, LangLeaveHoursDeduction, LangLeaveRejectedAt, LangLeaveRemainingDay, LangLeaveUpdate, LangMaritalStatus, LangMaxApproval, LangMaxDaysPerRequest, LangMaxReqAmount, LangMember, LangMessage, LangMessageTitle, LangMinNextClaim, LangMinReqAmount, LangMinute, LangMinuteAfterClockin, LangMinuteAfterClockout, LangMinuteBeforeClockin, LangName, LangNewPhotoProfile, LangNotificationMessage, LangOutsideAttendanceLocation, LangOvertimeRestriction, LangOvertimeSalaryType, LangOvertimeWages, LangOvertimeWagesHolidayCalendar, LangOvertimeWagesSaturday, LangOvertimeWagesSunday, LangPenalty, LangLateClockOutPenalty, LangLateClockOutPenaltyMinute, LangLateClockOutPenaltyNominalDesc, LangPermitDeduction, LangPosition, LangPositionId, LangPresenceNote, LangPresenceReview, LangPresenceRevisionNotification, LangProject, LangProjectName, LangQuota, LangRecapAutoClockOut, LangReceiver, LangRejectionReason, LangReligion, LangReminder, LangRepeatScheduleEveryWeek, LangReqAmount, LangRequestDate, LangRuleName, LangSalaryDetails, LangSalaryType, LangSchedule, LangScheduleName, LangShiftScheduleExchange, LangShowQuota, LangSpecialLeaveType, LangSpesificReceiver, LangStart, LangStartDate, LangStatus, LangTargetCount, LangTimeEnd, LangTimeEnd2, LangTimeStart, LangTimeStart2, LangTitle, LangTotalBreak, LangTotalDeduction, LangTotalEarnings, LangUsingDifferentDevice, LangValue, LangWages, LangWorkStatus, LangWorkTimeOut, LateAttendancePunishment, LateHours, maxBreak, Name, Note, NoteOnAttendFinishOvertime, NoteOnAttendIn, NoteOnAttendOut, NoteOnAttendStartOvertime, OvertimeHours, Password, PhoneNumber, ProfilePicture, ShiftWorkTime, StartWork, TardinessTolerance, TimeZone, WorkHours, WorkSchedule, LangBPJSEmployee, LangMaxRequestPerYear, LangMaxDaysPerYear, LangApprovedAt, LangEmployee, LangRejectedAt, LangParent, LangPositionAttendanceTargets2, LangClientName, LangVisitDate, LangLeaveDates, LangCanReplacePermitHour, LangApplyPermitHourDeduction, LangWorkHoursNotFulfilled, LangAbsenceDeductionsPerDay, LangAbsenceDeductionsPerDayRates, LangBankName, LangBankAccountNumber, LangBankAccountName, LangPreventClockInHolidaySchedule, LangPreventClockInHoliday, LangCode, LangUnitStock, LangStock, LangTotalStockUnit, LangSalesUnit, LangQty, LangUpdatedBy, LangAmountInUnits, LangQuotaStatus, LangNominal, LangPayrollReferenceType, LangApprover, LangPunishment, LangReprimandType, LangLeaveStartAt, LangTotalWorkingHours, LangWorkHoursFulfilled, LangTimeIn, LangTimeOut, LangMaxEmployees, LangNotes, LangDivisionTarget, LangPosition2, CompanyName, LangMonthStart, LangMonthEnd, LangAdditionalInformation, LangEducationLevel2, LangInstitution, LangMajor, LangPortfolioSite, LangSampleImage, LangAwardTitle, LangTitleOfAchievementOrContribution, LangYear, LangCertificateName, LangOrganizer, LangDateOfIssue, LangExpiredCertificate, LangOrganizationName, LangMinDaysBeforeLeave, LangPPH21Config, LangPreventClockInWithoutShiftSchedule, LangPreventUnscheduledOvertimeAttendance, LangMaxRequestPerMonth, LangMarkAsReadyToPay, LangCreatedBy, LangDeadline, LangTaskRepetition, LangPriority, LangTaskRepetitionDays, LangRepetitionType, LangRepetitionEnd, LangRepetitionAt, LangStartedAt, LangAssignedTo, LangFinishAt, LangTask, LangPenaltyType, LangPerHour, LangPerDay, LangPerMonth, LangMotherName, LangPaidLeaveId, LangUnpaidLeaveId } from './languange'

/**
 *
 * This files contains variable fields for each modules of history
 * purpose to display history data from api
 *
 */

/**
 * Personnel Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const payrollFields = {
  incomes: LangEarnings,
  total_income: LangTotalEarnings,
  deductions: LangDeduction,
  total_deduction: LangTotalDeduction,
  thp: 'THP',
  is_ready_to_pay: LangMarkAsReadyToPay
}

/**
 * Personnel Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const personnelFields = {
  name: Name,
  gender: Gender,
  phone_no: PhoneNumber,
  position: LangPosition,
  'position.name': LangPosition,
  pid: EmployeID,
  pid_file: EmployeIDFile,
  picture: ProfilePicture,
  leave_remaining_day: LangLeaveRemainingDay,
  leave_expired_at: LangLeaveExpiredAt,
  leave_eligible_at: LangLeaveStartAt,
  start_work: StartWork,
  'workStatus.name': LangWorkStatus,
  'group.name': Group,
  'identity.name': EmployeIdentityID,
  birth_date: LangBirthDate,

  // User fields : start_index = 13
  email: 'Email',
  password: Password,
  timezone: TimeZone,

  // Salary fields : start_index = 16
  type_id: LangSalaryType,
  overtime_type_id: LangOvertimeSalaryType,
  rate: LangWages,
  overtime_rate: LangOvertimeWages,
  saturday_overtime_rate: LangOvertimeWagesSaturday,
  sunday_overtime_rate: LangOvertimeWagesSunday,
  holiday_overtime_rate: LangOvertimeWagesHolidayCalendar,
  deduction_leave_in_hour: LangLeaveHoursDeduction,
  deduction_uncompleted_worktime_rate: LangWorkHoursNotFulfilled,
  deduction_absence_model: LangAbsenceDeductionsPerDay,
  deduction_absence_rate: LangAbsenceDeductionsPerDayRates,
  components: LangSalaryDetails,

  is_repeat_shift_schedule: LangRepeatScheduleEveryWeek,

  emergency_contacts: LangEmergencyContact,
  auto_reload_annual_leave: LangLeaveUpdate,

  birth_place: LangBirthPlace,
  'maritalStatus.name': LangMaritalStatus,
  'bloodGroup.name': LangBloodType,
  'religion.name': LangReligion,
  'cardAddressProvince.name': LangIdentityProvince,
  'cardAddressRegency.name': LangIdentityCity,
  card_address: LangIdentityAddress,
  'residenceAddressProvince.name': LangDomicileProvince,
  'residenceAddressRegency.name': LangDomicileCity,
  residence_address: LangDomicileAddress,
  'education.name': LangEducationLevel,
  education_graduation_year: LangGraduationYear,
  'education_institution_name': LangInstitutionName,
  education_major: LangEducationMajor,
  employee_id_number: LangEmployeeId,
  bpjs_config: LangBPJSEmployee,
  'bank.name': LangBankName,
  bank_account_name: LangBankAccountName,
  bank_account_number: LangBankAccountNumber,
  pph_config: LangPPH21Config,
  notes: LangNotes,
  mother_name: LangMotherName,
}

export const personnelFieldKeysArray = [...Object.keys(personnelFields)]

export const personnelAttrFields = {
  user: [...personnelFieldKeysArray.slice(personnelFieldKeysArray.indexOf('email'), personnelFieldKeysArray.indexOf('timezone') + 1)],
  payment_period: [...personnelFieldKeysArray.slice(personnelFieldKeysArray.indexOf('type_id'), personnelFieldKeysArray.indexOf('deduction_leave_in_hour') + 1)],
  is_repeat_shift_schedule: LangRepeatScheduleEveryWeek
}

/**
 * File Identity Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const fileIdentityFields = {
  'identity.name': LangIdentityType,
  'identity_number': LangIdentityNumber,
  'file.name': LangFile
}

/**
 * Personnel Document Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const personnelDocumentFields = {
  document_name: LangDocumentName,
  expired_at: LangExpiredDate,
  'file.name': LangFile,
  reminder_days: LangReminder,
  is_enable_reminder: `${LangActivate} ${LangReminder}`,
  is_free: LangQuotaStatus
}

/**
 * Group Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const groupFields = {
  name: Name,
  late_punishment: LateAttendancePunishment,
  bcc_division_customer_to: LangBccTo,
  required_note_1: NoteOnAttendIn,
  required_note_1_msg: NoteOnAttendIn,
  required_note_1_msg_en: `${NoteOnAttendIn} (EN)`,
  required_note_2: NoteOnAttendOut,
  required_note_2_msg: NoteOnAttendOut,
  required_note_2_msg_en: `${NoteOnAttendOut} (EN)`,
  required_note_5: NoteOnAttendStartOvertime,
  required_note_5_msg: NoteOnAttendStartOvertime,
  required_note_5_msg_en: `${NoteOnAttendStartOvertime} (EN)`,
  required_note_6: NoteOnAttendFinishOvertime,
  required_note_6_msg: NoteOnAttendFinishOvertime,
  required_note_6_msg_en: `${NoteOnAttendFinishOvertime} (EN)`,
  must_on_spot_1: LangAttendIn,
  must_on_spot_2: LangAttendOut,
  must_on_spot_3: LangAttendBreak,
  must_on_spot_4: LangAttendAfterBreak,
  must_on_spot_5: LangAttendOvertime,
  must_on_spot_6: LangAttendFinishOvertime,

  // Email Notif obj : start_index = 21
  different_device: LangUsingDifferentDevice,
  first_attendance: LangFirstTimeAttendance,
  out_of_spot: LangOutsideAttendanceLocation,

  limit_attendance_1_after_minute: LangMinuteAfterClockin,
  limit_attendance_1_before_minute: LangMinuteBeforeClockin,
  limit_attendance_2_after_minute: LangMinuteAfterClockout,
  auto_clock_out_after_minute: `${LangAutomaticClockout} ${LangMinuteAfterClockout}`,

  limit_attendance_holiday: LangPreventClockInHoliday,
  limit_attendance_holiday_schedule: LangPreventClockInHolidaySchedule,
  limit_attendance_without_schedule: LangPreventClockInWithoutShiftSchedule,
  limit_overtime_without_schedule: LangPreventUnscheduledOvertimeAttendance,

  spv_can_view_selfie: LangCanSeeSelfiePhoto,
  spv_can_view_map: LangCanSeeLocationMap,
  spv_can_view_device_info: LangCanSeeInfoDevice,
  spv_email_attendance_edit_request: LangPresenceRevisionNotification,
  spv_email_attendance_notes: LangPresenceNote,
  spv_email_attendance_review: LangPresenceReview,
  spv_email_permit_request: LangAnnualLeaveRequest,
  spv_email_leave_request: LangLeaveDayRequestNotif,
  spv_email_leave_in_hour_request: LangLeaveHourRequest,
  spv_email_switch_shift: LangShiftScheduleExchange,
  spv_can_edit_attendance: LangCanModifyPresence,
  spv_can_edit_document: LangCanModifyDocumentEmployee,
  spv_can_edit_personnel: LangCanModifyEmployee,
  spv_can_edit_personnel_annual_leave: LangCanModifyAnnualLeaveSetting,
  spv_can_edit_personnel_shift_schedule: LangCanModifyShiftSchedule,
  spv_limit_personnel_view: LangSpvLimitPersonnelView,
  spv_email_recap_autoclockout: LangRecapAutoClockOut,
  spv_email_late_attend_after_break: LangLateAfterBreak,
  switch_shift_enable: LangAllowShiftExchange,
  auto_clock_out_enable: LangAutomaticClockout,
  spv_email_whitelist_device: LangDeviceValidation,
  enable_device_validation: LangDeviceValidationActivate,
  client_visit_draggable_marker: LangDragableLocation,
  client_visit_enable: LangClientVisit,

  penalty_not_clock_out_enable: LangLateClockOutPenalty,
  penalty_not_clock_out_after_minute: LangLateClockOutPenaltyMinute,
  penalty_not_clock_out_nominal: LangLateClockOutPenaltyNominalDesc,
  min_days_before_leave: LangMinDaysBeforeLeave,
  annual_leave_max_days_per_request: LangMaxDaysPerRequest,
  annual_leave_max_request_per_month: LangMaxRequestPerMonth,
}

export const groupFieldKeysArray = [...Object.keys(groupFields)]

export const groupAttrFields = {
  email_notif_attendance_review: [...groupFieldKeysArray.slice(21, 24)],
  ...groupFieldKeysArray.slice(groupFieldKeysArray.findIndex(key => key === 'limit_attendance_1_after_minute'), groupFieldKeysArray.findIndex(key => key === 'client_visit_enable') + 1).reduce((curr, item) => ({ ...curr, [item]: groupFields[item] }), {})
}

/**
 * Group Late Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const groupLateFields = {
  is_active: LangActivation,
  minute: LangMinute,
  operator: 'Operator',
  penalty: LangPenalty
}

/**
 * Personnel Late Penalty Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const personnelLateFields = {
  is_active: LangActivation,
  minute: LangMinute,
  operator: 'Operator',
  penalty_type: LangPenaltyType,
  penalty: LangPenalty,
  hourly_penalty: LangPerHour,
  daily_penalty: LangPerDay,
  monthly_penalty: LangPerMonth
}

/**
 * Work Time Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const workTimeFields = {
  start_date: StartWork,
  'workPattern.name': LangScheduleName,
  'workPattern.tardiness_tolerance': TardinessTolerance
}

/**
 * Client Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const clientFields = {
  name: Name,
  address: Address,
  additional_fields: AdditionalField,
  latitude: 'Latitude',
  longitude: 'Longitude',
  radius: 'Radius',
  client_visit_must_on_spot: LangClientVisitMustOnSpot
}

/**
 * Work Shift Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const workShiftFields = {
  is_day_off: ShiftWorkTime,
  'shiftWorkPattern.name': LangScheduleName,
  'shiftWorkPattern.time_in': ClockIn,
  'shiftWorkPattern.time_out': ClockOut,
  'shiftWorkPattern.tardiness_tolerance': TardinessTolerance,
  'shiftWorkPattern.note': Note,
  note: LangAnnotation,
  date_time_out: LangWorkTimeOut
}

/**
 * Spot Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const spotFields = {
  name: Name,
  latitude: 'Latitude',
  longitude: 'Longitude',
  address: Address,
  radius: 'Radius',
  personnels: LangChangeSpcEmployee,
  groups: LangChangeSpcGroup
}

/**
 * Shift Pattern Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const shiftPatternFields = {
  name: Name,
  note: Note,
  tardiness_tolerance: TardinessTolerance,
  time_in: ClockIn,
  time_out: ClockOut,
  break_range_start: Break,
  break_range_end: AfterBreak,
  break_max_minutes: maxBreak,
  color: Color
}

/**
 * Shift Pattern Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const workPatternFields = {
  name: Name,
  tardiness_tolerance: TardinessTolerance,
  schedules: WorkSchedule
}

/**
 * Attendance Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const attendanceFields = {
  date: `${LangSchedule} - ${DateLang}`,
  time_in: `${LangSchedule} - ${LangAttendIn}`,
  time_out: `${LangSchedule} - ${LangAttendOut}`,
  total_working_hours: LangTotalWorkingHours,
  tardiness_tolerance: `${LangSchedule} - ${TardinessTolerance}`,
  mark_approve: LangPresenceReview,
  log_date_time: LangAttendanceDate,
  late_seconds: LangLateness,
  penalty_late_fee: LangLateCharge,
  total_work_minute: WorkHours,
  total_overtime_minute: OvertimeHours,
  total_late_minute: LateHours,
  late_tolerance_seconds: LangLateToleranceSecond,
  total_break_minute: LangTotalBreak,
  is_work_completed: LangWorkHoursFulfilled,

  device_id: LangDeviceId,
  device_manufacturer: LangDeviceManufacture,
  device_model: LangDeviceModel,
  device_name: LangDeviceName,
  device_type: LangDeviceType,

  penalty_not_clock_out_fee: LangLateClockOutPenaltyNominalDesc,

  reject_reason: LangRejectionReason,
  rejected_at: LangRejectedAt
}

export const attendanceFieldKeysArray = [...Object.keys(attendanceFields)]

export const attendanceAttrFields = {
  mark_approve: attendanceFields.mark_approve,
  late_tolerance_seconds: attendanceFields.late_tolerance_seconds,
  schedule: [...attendanceFieldKeysArray.slice(attendanceFieldKeysArray.indexOf('date'), attendanceFieldKeysArray.indexOf('tardiness_tolerance') + 1)],
  device_info: [...attendanceFieldKeysArray.slice(attendanceFieldKeysArray.indexOf('device_id'), attendanceFieldKeysArray.indexOf('device_type') + 1)]
}

/**
 * Leave & Annual Leave Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const permitLeaveFields = {
  status: 'Status',
  desc: LangDescription,
  is_exclude_deduction: LangPermitDeduction,
  note: LangNotes,
  dates: DateLang,
  approval_steps: LangApprovalStatus
}

/**
 * Leave & Annual Leave Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const leaveRequestDateFields = {
  date: LangLeaveDates
}

/**
 * Attendance Edit Request Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const attendanceEditRequestFields = {
  note: Note,
  status: 'Status'
}

/**
 * Holiday Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const holidayFields = {
  description: LangDescription,
  description_en: `${LangDescription} (EN)`,
  date: DateLang
}

/**
 * Broadcast Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const broadcastFields = {
  status: 'Status',
  target_id: `${LangSpesificReceiver} ID`,
  except_id: `${LangExceptionReceiver} ID`,
  target_count: LangTargetCount,
  title: LangTitle,
  message_title: LangMessageTitle,
  message_title_en: `${LangMessageTitle} (EN)`,
  message_content_notif: LangNotificationMessage,
  message_content_notif_en: `${LangNotificationMessage} (EN)`,
  target_type: LangReceiver,
  message_content: LangMessage,
  message_content_en: `${LangMessage} (EN)`
}

/**
 * Approval Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const approvalFields = {
  approved_at: LangLeaveApprovedAt,
  date: LangAttendanceDate,
  is_approved: 'Status'
}

/**
 * Reimbursement Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const reimbursementFields = {
  assign_to_new_personnel: LangAssignToNewEmployee,
  description: LangDescription,
  effective_date: LangEffectiveDate,
  expired_in: LangExpiredIn,
  max_req_amount: LangMaxReqAmount,
  min_next_claim: LangMinNextClaim,
  min_req_amount: LangMinReqAmount,
  name: LangName,
  quota: LangQuota,
  show_quota_to_personnel: LangShowQuota
}

/**
 * Reimbursement Personnel Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const reimbursementPersonnelFields = {
  expired_in: LangExpiredIn,
  balance: LangBalance
}

/**
 * Reimbursement Request Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const reimbursementRequestFields = {
  approved_at: LangLeaveApprovedAt,
  rejected_at: LangLeaveRejectedAt,
  status: 'Status',
  description: LangDescription,
  expenses: LangExpenses,
  request_date: LangRequestDate,
  reject_reason: LangRejectionReason,
  request_amount: LangReqAmount,
  approval_amount: LangApprovalAmount,
  add_to_personnel_payroll: LangAddToPersonnelPayroll
}

/**
 * Device Approval Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const deviceApprovalFields = {
  status: 'Status',
  device_id: LangDeviceId,
  device_manufacturer: LangDeviceManufacture,
  device_model: LangDeviceModel,
  device_name: LangDeviceName,
  device_type: LangDeviceType
}

/**
 * Client Visit Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const clientVisitFields = {
  client_name: Name,
  date_time_end: LangEndDate,
  date_time_start: LangStartDate,
  latitude_start: `Latitude ${LangStart}`,
  latitude_end: `Latitude ${LangEnd}`,
  longitude_start: `Longitude ${LangStart}`,
  longitude_end: `Longitude ${LangEnd}`,
  note_start: `${Note} ${LangStart}`,
  note_end: `${Note} ${LangEnd}`
}

/**
 * Payroll Deduction Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const payrollDeductionFields = {
  name: LangDescription,
  deduction_nominal: 'Nominal'
}

/**
 * Payroll Bonus Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const payrollBonusFields = {
  name: LangDescription,
  bonus_nominal: 'Nominal'
}

/**
 * Leave Request Hour Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const leaveRequestHourFields = {
  status: 'Status',
  is_fulfilled: LangFullfilled,
  note: Note,
  time_from: LangTimeStart,
  time_to: LangTimeEnd,
  can_replace: LangCanReplacePermitHour,
  is_apply_deduction: LangApplyPermitHourDeduction
  // time_from: Langstart
}

/**
 * Special Leave Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const specialLeaveFields = {
  type: LangSpecialLeaveType,
  is_active: LangStatus,
  max_days: LangMaxDaysPerRequest,
  max_request_per_year: LangMaxRequestPerYear,
  max_days_per_year: LangMaxDaysPerYear
}

/**
 * Timesheet Activity Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const timesheetActivityFields = {
  note: LangJobDescription,
  'createdBy.name': LangCreatedBy2,
  'project.name': LangProject,
  status: LangStatus,
  date_time_start: LangStartDate,
  start_time: LangTimeStart,
  date_time_end: LangEndDate,
  end_time: LangTimeEnd,
  duration: LangDuration
}

/**
 * Timesheet Activity Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const timesheetProjectFields = {
  name: LangProjectName,
  color: Color,
  members: LangMember
}

/**
 * Overtime Schedule Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const overtimeScheduleFields = {
  date_time_start: LangTimeStart2,
  date_time_end: LangTimeEnd2,
  description: Note,
  limit_attendance_before_minute: LangOvertimeRestriction,
  status: LangStatus,
  approval_steps: LangApprovalRules
}

/**
 * Approval Rules Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const approvalRuleFields = {
  name: LangRuleName,
  system_ids: LangApplicableOn,
  approval_steps: LangApprovalRules,
  target: LangApplicableTo,
  max_approval_days: LangMaxApproval,
}

/**
 * Personnel Profile Picture Request Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const personnelProfilePictureRequestFields = {
  note: Note,
  picture: LangNewPhotoProfile,
  status: 'Status'
}

/**
 * Pintu Kerjoo Attendance Approval Request Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const pintuKerjooApprovalRequestFields = {
  approved_at: LangApprovedAt,
  personnel_id: `ID ${LangEmployee}`,
  log_date_time_local: LangAttendanceDate
}

/**
 * Position Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const positionFields = {
  name: LangName,
  'parent.name': LangParent,
  targets: LangPositionAttendanceTargets2
}

/**
 * Client Visit Schedule Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const clientVisitScheduleFields = {
  'client.name': LangClientName,
  'client.address': Address,
  'client.latitude': 'Latitude',
  'client.longitude': 'Longitude',
  'client.radius': 'Radius',
  client_visit_must_on_spot: LangClientVisitMustOnSpot,
  date: LangVisitDate,
  start_time: LangTimeStart,
  end_time: LangTimeEnd
}

/**
 * Product Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const productFields = {
  code: LangCode,
  name: LangName,
  'stockUnit.name': LangUnitStock,
  stock: LangStock,
  stock_total_item_count: LangTotalStockUnit,
  stock_sales: LangSalesUnit
}

/**
 * Stock Update Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const stockUpdateFields = {
  amount: LangQty,
  'product.name': LangName,
  'stockUnit.name': LangUnitStock,
  'createdBy.name': LangUpdatedBy,
  note: LangNotes
}

/**
 * Stock Update Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const stockUnitFields = {
  name: LangName,
  item_count: LangAmountInUnits,
}

/**
 * Payroll Reference Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const payrollReferenceFields = {
  name: LangDescription,
  nominal: LangNominal,
  type: LangPayrollReferenceType,
}

/**
 * Reprimand Type Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const reprimandTypeFields = {
  name: LangName,
  description: LangDescription,
  approver: LangApprover
}

/**
 * Reprimand Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const reprimandFields = {
  approval_status: LangApprovalStatus,
  approver: LangApprover,
  effective_date: LangEffectiveDate,
  expired_date: LangExpiredDate,
  penalty: LangPunishment,
  'personnel.name': LangEmployee,
  'reprimandType.name': LangReprimandType
}

/**
 * Openshift Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const openshiftFields = {
  date_time_start: LangTimeIn,
  date_time_end: LangTimeOut,
  max_personnel: LangMaxEmployees,
  note: LangNotes,
  groups: LangDivisionTarget,
  hourly_wages: LangWages
}

/**
 * Work Experience Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const workExperienceFields = {
  position: LangPosition2,
  company_name: CompanyName,
  start_date: LangMonthStart,
  end_date: LangMonthEnd,
  additional_information: LangAdditionalInformation,
}

/**
 * Education Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const educationFields = {
  'educationLevel.name': LangEducationLevel2,
  institution_name: LangInstitution,
  major: LangMajor,
  start_date: LangMonthStart,
  end_date: LangMonthEnd,
  additional_information: LangAdditionalInformation,
}

/**
 * Portfolio Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const portfolioFields = {
  url: LangPortfolioSite,
  image: LangSampleImage,
  additional_information: LangAdditionalInformation,
}

/**
 * Award Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const awardFields = {
  title: LangAwardTitle,
  detail: LangTitleOfAchievementOrContribution,
  year: LangYear,
  additional_information: LangAdditionalInformation,
}

/**
 * Certificate Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const certificateFields = {
  name: LangCertificateName,
  organizer: LangOrganizer,
  start_date: LangDateOfIssue,
  end_date: LangExpiredCertificate,
  additional_information: LangAdditionalInformation,
}

/**
 * Organization Experience Fields
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const organizationExperienceFields = {
  position: LangPosition2,
  name: LangOrganizationName,
  start_date: LangMonthStart,
  end_date: LangMonthEnd,
  additional_information: LangAdditionalInformation,
}

/**
 * Task
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const taskFields = {
  'creator.name': LangCreatedBy,
  title: LangTitle,
  detail: LangDescription,
  end_time: LangDeadline,
  is_repeat_activated: LangTaskRepetition,
  priority: LangPriority,
  'project.name': LangProjectName,
  repeat_interval: LangTaskRepetitionDays,
  repeat_type: LangRepetitionType,
  repeat_until: LangRepetitionEnd,
  repeat_at: LangRepetitionAt,
  start_time: LangTimeStart2,
  status: LangStatus,
  started_at: LangStartedAt,
  personnels: LangAssignedTo,
  end_at: LangFinishAt,
}

/**
 * Task Discussion
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const taskDiscussionFields = {
  'task.title': LangTask,
  detail: LangMessage
}

/**
 * Leave Request & Permit Discussion
 * --------------------------------------------------------------------------------------------------------------------------------------------------------------------
 */
export const leaveRequestDiscussionFields = {
  leave_request_id: LangPaidLeaveId,
  detail: LangMessage
}

export const permitDiscussionFields = {
  permit_id: LangUnpaidLeaveId,
  detail: LangMessage
}

